/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ApiResponse, ClientAddOn, Invoice } from '@core/models';
import { Client, CompanyTypesEnum } from '@truckstop-tms/zuum-lib';
import { ApiService } from 'app/services/api.service';
import { AddOn } from './../models/add-on.model';
import { GlobalPriceConfiguration } from '../models/global-price-configuration.model';

@Injectable({
  providedIn: 'root',
})
export class ClientAddOnService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  getClientAddons(clientId: number, companyType: CompanyTypesEnum): Observable<ApiResponse<AddOn[]>> {
    return this.http
      .get<ApiResponse>(`${this.apiService.superAdminApi}/client-add-on/${clientId}/${companyType}`)
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  initializeAddonsFromSuperAdmin(
    addOns: { defaultAdddOns: GlobalPriceConfiguration[]; addOnsEnabledByManager: GlobalPriceConfiguration[] },
    client: Client,
    updatedBy: string
  ): Observable<ApiResponse<ClientAddOn[]>> {
    return this.http
      .post<ApiResponse>(`${this.apiService.superAdminApi}/client-add-on/initialize/super-admin`, {
        addOns,
        client,
        updatedBy,
      })
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  activate(
    clientAddOn: Partial<ClientAddOn>
  ): Observable<ApiResponse<{ addOn: ClientAddOn; invoice: Invoice | null }>> {
    return this.http
      .post<ApiResponse>(`${this.apiService.superAdminApi}/client-add-on/activate`, {
        ...clientAddOn,
        client: { id: clientAddOn.client?.id },
        // id: null,
      })
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  deactivate(clientAddOn: Partial<ClientAddOn>): Observable<ApiResponse<ClientAddOn>> {
    return this.http
      .post<ApiResponse>(`${this.apiService.superAdminApi}/client-add-on/deactivate`, {
        ...clientAddOn,
        client: { id: clientAddOn.client?.id },
      })
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }
}
